module.exports = __webpack_public_path__ + "img/ani_icon_preparing.ace9667f.gif";